import { fetchAll } from '@/api/ProductTypeApi'

export default {
  getAll ({ commit }) {
    return fetchAll()
      .then(response => {
        commit('setAll', response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  }
}
